module.exports = __webpack_public_path__ + "img/powerline.bef6b078.png";